import React, { useEffect, useState } from "react";
import { Option } from "../../components/Atomos/DropDown/DDMultiple";
import CatalogTableC from "../../components/Catalogs/CatalogTableC";
import PaginatedTable from "../../components/Organismos/Table/PaginatedTable";
import ShapeEdit from "../../components/Atomos/Icons/ShapeEdit";
import useDataLoader2 from "../../hooks/useDataLoader2";
import { useStatesList } from "../../hooks/Catalogs/useStates";
import { UseCountryList } from "../../hooks/Catalogs";
import { UseRegionList } from "../../hooks/Catalogs/useRegionListOptions";
import { ICity } from "../../interfaces";
import { defaultPageSize } from "../../utils/const";
import Filters, { IFilterData } from "../../components/Catalogs/Filters/Filters";
import PersistentLink from "../../components/Moleculas/PersistentLink";
import { formatTimeSpanToString } from "../../utils/functions";
import { exportAllDataLoader2 } from "../../utils/exportAllDataLoader2";

const City: React.FC = () => {
  const { statesData } = useStatesList()
  const { countryData } = UseCountryList()
  const {regionData}  = UseRegionList()
  const [statesByCountry, setStatesByCountry] = useState<Option[]>();
  const fields = [
    'id', 
    'legacyId',
    'name', 
    'state',
    'stateName',
    'countryName',
    'regionNames',
    'createdDate'
  ]
  const endpoint = '/city';

  const { 
    data, 
    totalCount, 
    fetchData, 
    setFilter, 
    sort, 
    setSort, 
    pagination, 
    setPagination,
    filter,
    inputFilters,
    setInputFilters
  } = useDataLoader2<any>({
    endpoint,
    defaultPageSize,
    fields,
    defaultSorting: { field: "name", order: "asc" },
  });

  const columnsDef = React.useMemo(() => [
    {
      id: "count",
      header: "#",
      enableSorting: false,
      cell: ({ rowIndex }: { rowIndex: number; row: any; value: any }) => (
        <p> {rowIndex + 1 + pagination.pageIndex * pagination.pageSize} </p>
      ),
    },
    { id: 'name', header: 'Name' },
    { id: 'country', header: 'Country' },
    { id: 'state', header: 'State' },
    { id: 'regions', header: 'Regions' },
    { id: 'createdDate', header: "Created Date" },
    {
      id: 'edit',
      header: 'Edit',
      enableSorting: false,
      cell: ({ row }: { rowIndex: number; row: any; value: any }) => (
        <PersistentLink
          className="edit"
          to={`Edit/${row.id}`}
          state={row}
          persistingData={{
            pagination,
            sort,
            filter, 
            inputFilters, 
          }}
        >
          Edit{" "}
          <div className="editsvg">
            <ShapeEdit />
          </div>{" "}
        </PersistentLink>
      ),
    },
  ], [pagination.pageIndex, pagination.pageSize, sort, filter, inputFilters]);

  const formatData = (data: ICity[]) => {
    const formattedData = data.map(d => {
      return {
        ...d,
        state: d.stateName,
        country: d.countryName,
        regions: d.regionNames,
        createdDate: d.createdDate ? formatTimeSpanToString(d.createdDate) : '',
      };
    });
    return formattedData;
  };

  useEffect(() => {
    setStatesByCountry(
      statesData.filter(s => filter?.countries?.value?.includes(s.country))
    )
  }, [filter?.countries]);

  const filtersData: IFilterData[] = React.useMemo(() => [
    {
      name: "Name",
      type: "text",
      comparison: "CONTAINS",
    },
    {
      name: "Region",
      fieldName: "regions",
      objectData: regionData?.map(r => ({id: r.id, name:r.name})) || [],
    },
    {
      name: "Country", 
      objectData: countryData?.map(c => ({id: c.id, name: c.name})) || [],
    },
    {
      name: "State",
      fieldName: "states",
      objectData: statesByCountry || [],
      disabled: !statesByCountry?.length
    },
  ], [regionData, countryData, statesByCountry]);

  return (
    <>
        <CatalogTableC
          title={`City Catalog`}
          catalogName={"CITIES"}
          catalogShortName={"CITY"}
          route={"City"}
          totalCount={totalCount}
        >
          <Filters
            filtersData={filtersData} 
            filterValues={inputFilters}
            setFilterValues={setInputFilters} 
            Search={() => fetchData()}
            clearSelections={() => fetchData(true)}
            setValueForQuery={setFilter}
          />
          <PaginatedTable
            data={data || []}
            columnsDef={columnsDef}
            formatData={formatData}
            sorting={sort}
            onSortingChange={setSort}
            totalCount={totalCount || 0}
            pagination={pagination}
            onPaginationChange={setPagination}
            endpoint={endpoint}
            onExportAll={() =>
              exportAllDataLoader2<any>({
                endpoint,
                filter,
                sort,
                pageSize: 1000,
                fields,
              })
            }
          />
        </CatalogTableC>
    </>
  );
};

export default City;
